import React, {Fragment, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Popover, Carousel} from 'antd'
import _ from 'lodash'
import Attribute from './Attribute'
import {withOrderFormContext} from '../../contexts'
import classnames from 'classnames'
import {withMattingTypePricing, shouldUseMattingTypePricing, getMattingPrice} from '../../hooks/withMattingTypePricing'
import {getDescription} from '../../utils/paper-type-description'

function AttributesSelection(props) {
  const {
    hoveredAttribute,
    attributes,
    selectedAttributes,
    setSelectedAttribute,
    clearSelectedAttribute,
    showHoveredAttribute,
    frameSize,
    checkAttributeLogic,
    selectedMattingType,
    isMattingStuff,
    selectedPaperType
  } = props

  const shouldDisplay = attribute => {
    return 'input' === attribute.type || checkAttributeLogic(attribute)
  }

  const selectedValue = attribute => {
    let found = selectedAttributes.filter(
        selectedAttribute => selectedAttribute.id === attribute.id)[0]

    return found ? found.value : null
  }

  const shouldSelectDefaultValue = attribute => {

    return '' !== attribute.default_value &&
        null === selectedValue(attribute) &&
        attribute.default_value !== selectedValue(attribute)
  }

  useEffect(() => {
    selectedAttributes.forEach(attribute => {
      // Unselect the hidden attribute
      if (false === shouldDisplay(attribute) && 0 === attribute.label.indexOf('Frame Colours')) {
        clearSelectedAttribute(attribute)
      }
    })

    attributes.forEach(attribute => {
      if (shouldSelectDefaultValue(attribute)) {
        setSelectedAttribute(attribute, attribute.default_value)
      }
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAttributes])

  const _getShowHoverAttributeStatus = (attribute) => {
    if (showHoveredAttribute) {
      if (attribute.type !== 'select') return false

      return _.some(attribute.options, {id: hoveredAttribute.id})
    }

    return false
  }

  const details = () => {
    const hasImages = !!hoveredAttribute.images
    const images = hasImages ? JSON.parse(hoveredAttribute.images) : []
    let popupClassBasedOnImages = ''
    let price = hoveredAttribute.price

    if (images.length > 0) {
      popupClassBasedOnImages = 'simple-layout'
    }

    // PM-492
    if(isMattingStuff && shouldUseMattingTypePricing(hoveredAttribute)) {
      price = withMattingTypePricing(price, getMattingPrice(selectedMattingType(), selectedPaperType()), selectedMattingType())
    }

    return (
      <div className={`AttributePopup ${popupClassBasedOnImages}`}>
        <Carousel autoplay effect="fade" autoplaySpeed={2000}>
          {images.map(image => (
            <img alt={''} key={image} src={image}
              className="popup-thumbnail" style={{ width: '410px' }}/>
          ))}
        </Carousel>
        <div className="popup-body mt-2">
          <span className="popup-content">{hoveredAttribute.label ||
            hoveredAttribute.value}</span>
          <span className="popup-content">${price}</span>
        </div>
        {hoveredAttribute.value && getDescription(hoveredAttribute.value) && (
          <div className="popup-body" style={{ marginTop: '5px' }}>
            <div className="space-y-2 popup-content" dangerouslySetInnerHTML={{ __html: getDescription(hoveredAttribute.value) }}/>
          </div>
        )}
      </div>
    )
  }

  const attributeList = attributes.map(attribute => {
    const value = selectedAttributes.filter(
        selectedAttribute => selectedAttribute.id === attribute.id)[0]

    const onValueChange = (value) => {
      setSelectedAttribute(attribute, value)
    }

    return (
        <Fragment key={attribute.code}>
          {shouldDisplay(attribute) && (
              <Popover
                  content={details()}
                  placement="left"
                  arrowPointAtCenter
                  visible={_getShowHoverAttributeStatus(attribute)}
                  autoAdjustOverflow={false}
                  getPopupContainer={(node) => {
                    return node
                  }}
              >
                <div>
                  <Attribute
                      key={attribute.code}
                      value={value}
                      onChange={onValueChange}
                      {...attribute}
                  />
                </div>
              </Popover>
          )}
        </Fragment>
    )
  })

  return frameSize &&
      <div className={classnames('AttributeWrapper', {
        'aussie-made-circle': true === hoveredAttribute.aussie
      })}>
        {!!attributes.length && attributeList}
      </div>
}

AttributesSelection.propTypes = {
  hoveredAttribute: PropTypes.object,
  attributes: PropTypes.array,
  selectedAttributes: PropTypes.array,
  setSelectedAttribute: PropTypes.func.isRequired,
  showHoveredAttribute: PropTypes.bool,
  frameSize: PropTypes.object,
  checkAttributeLogic: PropTypes.func.isRequired,
  checkOptionLogic: PropTypes.func.isRequired,
}

export default withOrderFormContext(context => ({
  hoveredAttribute: context.hoveredAttribute,
  attributes: context.availableProductAttributes,
  selectedAttributes: context.selectedAttributes,
  setSelectedAttribute: context.setSelectedAttribute,
  clearSelectedAttribute: context.clearSelectedAttribute,
  frameSize: context.frameSize,
  submitForm: context.submitForm,
  isSubmitting: context.isSubmitting,
  showHoveredAttribute: context.showHoveredAttribute,
  checkAttributeLogic: context.checkAttributeLogic,
  checkOptionLogic: context.checkOptionLogic,
  selectedMattingType: context.selectedMattingType,
  isMattingStuff: context.isMattingStuff,
  selectedPaperType: context.selectedPaperType
}))(AttributesSelection)
